import JobDetails from "../sharedLandingcomponents/Job_Details_Comp";
import "../sharedLandingcss/Site.css";
import "../sharedLandingcss/Site_Animate.css";

const JobDetailsPage = () => {
  return (
    <div className="min-h-[400px]">
      <JobDetails></JobDetails>
    </div>
  );
};

export default JobDetailsPage;
